import React from 'react';

const containerStyle = {
    minHeight: '100vh',
    display: 'grid',
    placeItems: 'center',
    padding: '24px',
    background: 'linear-gradient(-40deg, #f9f9f9 0%, #adacac 100%)',
};

export default function AuthLayout({ children }) {
    return <div style={containerStyle}>{children}</div>;
}
